module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-icon', {
    attrs: {
      "large": _vm.large
    }
  }, [_vm._v("mdi-" + _vm._s(_vm.icon))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-357d0150"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Utils/FileIcon.vue
// module id = 1006
// module chunks = 1